document.addEventListener('DOMContentLoaded', function(){
  setTimeout(function(){
    const iframe = document.querySelector('.video-div');
    if (iframe){
      const iWindow = iframe.contentWindow;
      const iDocument = iWindow.document;

      // accessing the element
      const element = iDocument.querySelector('.html5-video-player');
      element.style.background.color = 'white';
    }    
  }, 800);
});